export default __webpack_public_path__ + "static/assistencia-959148374da5e314519d9dd32bcfb14b.png";